import url from '../url'
import headers from '../headers'

export default {
	getStaticContent (context, name) {
		return context.$http.get(
			`${url}/staticcontent/${name}/`,
			headers.bearer()
		)
	},
	editStaticContent (context, name, model) {
		return context.$http.put(
			`${url}/staticcontent/${name}/`,
			model,
			headers.bearer()
		)
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/statics.js